import { render, staticRenderFns } from "./ConfirmationSentPane.vue?vue&type=template&id=92df82a6&scoped=true"
import script from "./ConfirmationSentPane.vue?vue&type=script&lang=ts"
export * from "./ConfirmationSentPane.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationSentPane.vue?vue&type=style&index=0&id=92df82a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92df82a6",
  null
  
)

export default component.exports